import React from 'react';
import PropTypes from 'prop-types';
import CardHeader from '@material-ui/core/CardHeader';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';

const Settings = ({ children, isLoading, title }) => (
  <Card style={{ marginBottom: 8 }}>
    <CardHeader title={title} titleTypographyProps={{ variant: 'subtitle2' }} />
    <Divider />
    <LoadingWrapper isLoading={isLoading}>{children}</LoadingWrapper>
  </Card>
);

Settings.propTypes = {
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
};

Settings.defaultProps = {
  isLoading: true,
  children: undefined,
};

export default Settings;
